import React, { Component } from 'react';
import MainPage from '../components/main-page/main-page';
import './style.scss';
import Nav from '../components/shared/nav/nav';
import { Route, Switch } from 'react-router';
import Services from '../components/services/services';
import Contact from '../components/say-hello/contact';
import About from '../components/about/about';

class App extends Component {
  render() {
    return (
      <div className="container-fluid">
        <Nav />
        <Switch>
          <Route exact path="/" component={MainPage} />
          <Route exact path="/services" component={Services} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/about" component={About} />
        </Switch>
      </div>
    );
  }
}

export default App;
